import React from 'react';
import Image01 from '../../../assets/images/simulation/che/12/01/che1.png';
import Image02 from '../../../assets/images/simulation/che/12/01/che2.png';
import Image03 from '../../../assets/images/simulation/che/12/01/che3.png';
import Image04 from '../../../assets/images/simulation/che/12/01/che4.png';
import Image05 from '../../../assets/images/simulation/che/12/01/che5.png';
import Image06 from '../../../assets/images/simulation/che/12/01/che6.png';
import Image07 from '../../../assets/images/simulation/che/12/01/che7.png';
import Image08 from '../../../assets/images/simulation/che/12/01/che8.png';

const CheTheoryTemplate = () => {
  return (
    <div className="flex flex-wrap text-lg font-body text-gray-900 leading-relaxed tracking-wide px-4 py-5 ">
      {/* Content 1 */}
      <div className="mb-2 ">
        <h2 className="font-semibold"> পরীক্ষণের নাম: </h2>
        <p>
          {' '}
          KMnO₄ দ্রবন দ্বারা অজানা ঘনমাত্রার দ্রবনে ফেরাস আয়নের পরিমান নির্ণয়।{' '}
        </p>
      </div>

      <div className="mb-2">
        <h2 className="font-semibold"> পরীক্ষণের উদ্দেশ্য: </h2>
        <p>
          KMnO₄ সমাধানের একটি আদর্শ সমাধানের বিপরীতে টাইট্রেট করে এর শক্তি
          নির্ধারণ করা:
        </p>
        <ul className="list-inside leading-loose list-disc">
          <li>অক্সালিক অ্যাসিড</li>
          <li>লৌহঘটিত অ্যামোনিয়াম সালফেট (মোহরের লবণ)</li>
        </ul>
      </div>
      {/* Content 2 */}
      <div className="mb-4">
        <h2 className="font-semibold"> মূলতত্ত্ব: </h2>
        <p> টাইট্রেশন কি?</p>

        <p>
          টাইট্রেশন হল গুণগত রাসায়নিক বিশ্লেষণের একটি সাধারণ পরীক্ষাগার পদ্ধতি
          যা একটি সমাধানের (বিশ্লেষণ) অজানা ঘনত্ব নির্ধারণ করতে ব্যবহার করা যেতে
          পারে। এই প্রক্রিয়ার ভিত্তি হল বিশ্লেষক এবং অজানা ঘনত্বের (মান সমাধান)
          সমাধানের মধ্যে প্রতিক্রিয়া। বিশ্লেষকটি একটি পাইপেট ব্যবহার করে একটি
          শঙ্কুযুক্ত ফ্লাস্কে নেওয়া হয় এবং পরিচিত ঘনত্বের সমাধানটি একটি
          ক্যালিব্রেটেড বুরেটে (টাইট্রান্ট) নেওয়া হয়।
        </p>
      </div>
      {/* Content 3 */}
      <div className="mb-2 mt-2">
        <h2 className="font-semibold">
          অক্সিডেশন-রিডাকশন টাইট্রেশন এবং রেডক্স টাইট্রেশন{' '}
        </h2>
        <p>
          টাইট্রান্ট এবং বিশ্লেষকের মধ্যে জারণ এবং হ্রাস প্রতিক্রিয়ার উপর
          ভিত্তি করে টাইট্রেশনকে রেডক্স টাইট্রেশন বলে। জারণ হল অক্সিজেন সংযোজন
          বা হাইড্রোজেন/ইলেকট্রন অপসারণের প্রক্রিয়া এবং হ্রাসের মধ্যে
          হাইড্রোজেন/ইলেকট্রন যুক্ত করা বা অক্সিজেন অপসারণের প্রক্রিয়া জড়িত।
          অক্সিডাইজিং এজেন্ট হল এমন পদার্থ যা এক বা একাধিক ইলেকট্রন লাভ করে এবং
          হ্রাস পায়। হ্রাসকারী এজেন্টগুলি এমন পদার্থ যা এক বা একাধিক ইলেকট্রন
          হারায় এবং অক্সিডাইজড হয়। অর্থাৎ, অক্সিডাইজিং এজেন্ট হল ইলেকট্রন
          গ্রহণকারী, এবং হ্রাসকারী এজেন্ট হল ইলেকট্রন দাতা।
        </p>
        <p className="mt-2">
          রেডক্স সিস্টেমে, রেডক্স-সংবেদনশীল সূচক ব্যবহার করে একটি
          রিডাক্ট্যান্ট/অক্সিডেন্টের শক্তি নির্ধারণের জন্য টাইট্রেশন পদ্ধতিটি
          অভিযোজিত করা যেতে পারে। পটাসিয়াম পারম্যাঙ্গনেট জড়িত রেডক্স
          টাইট্রেশনকে পারম্যাঙ্গানোমেট্রিক টাইট্রেশন বলা হয়। এই
          প্রতিক্রিয়াগুলিতে, MnO4- আয়নগুলি স্ব নির্দেশক হিসাবে কাজ করে।
        </p>
      </div>
      {/* Content 4 */}
      <div className="mb-2 mt-2">
        <h2 className="font-semibold">
          অক্সালিক অ্যাসিডের বিরুদ্ধে KMnO₄ এর টাইট্রেশন
        </h2>
        <p>
          অক্সালিক অ্যাসিডের স্ট্যান্ডার্ড দ্রবণ তৈরি [250 মিলি এম/10 (0.1 এম)
          দ্রবণ] <br />
          স্ফটিক অক্সালিক অ্যাসিডের আণবিক ভর হল, H2C2O4.2H2O = 126 <br />1 M
          দ্রবণের 1000 মিলি প্রস্তুত করতে অক্সালিক অ্যাসিড ক্রিস্টালের ওজন = 126
          গ্রাম
        </p>
        <div className="mt-1 flex flex-wrap">
          <p>
            অতএব, 250 মিলি 0.1 এম দ্রবণ প্রস্তুত করতে অক্সালিক অ্যাসিডের ওজন
            প্রয়োজন ={' '}
          </p>
          <img src={Image01} alt="simulation-theory" className="-mt-4 ml-1" />
        </div>
        <p className="mt-2">
          অক্সালিক অ্যাসিডের একটি আদর্শ দ্রবণ ব্যবহার করে KMnO₄ এর শক্তি
          নির্ধারণ
          <br />
          এই টাইট্রেশনে, KMnO₄ হল টাইট্রেন্ট এবং অক্সালিক অ্যাসিড হল বিশ্লেষক।
          এখানে, পটাসিয়াম পারম্যাঙ্গনেট হল অক্সিডাইজিং এজেন্ট এবং অক্সালিক
          অ্যাসিড হ্রাসকারী এজেন্ট। পটাসিয়াম পারম্যাঙ্গনেট এবং অক্সালিক
          অ্যাসিডের মধ্যে বিক্রিয়াটি একটি অম্লীয় মাধ্যমে সঞ্চালিত হয় কারণ
          অম্লীয় মাধ্যমের পারম্যাঙ্গনেট আয়ন একটি অত্যন্ত শক্তিশালী অক্সিডাইজিং
          এজেন্ট। ডাইলুট সালফিউরিক অ্যাসিড যোগ করে অম্লতা প্রবর্তন করা হয়।
        </p>
        <img src={Image02} alt="simulation-theory" className="py-2" />
        <p>
          শেষবিন্দু নির্ধারণ করতে অন্য কোনো সূচক ব্যবহার করা হয় না কারণ KMnO₄
          নির্দেশক হিসেবে কাজ করে। পারম্যাঙ্গানেট (MnO4-) আয়নের গাঢ় বেগুনি রঙ
          রয়েছে। একটি অম্লীয় মাধ্যমে, MnO4- বর্ণহীন ম্যাঙ্গানাস (Mn2+) আয়নে
          পরিণত হয়। শেষ বিন্দুতে পৌঁছানোর পর, পারম্যাঙ্গনেটের শেষ একক ড্রপ যোগ
          করলে দ্রবণটিতে হালকা গোলাপি রঙ আসে। টাইট্রেশনের সময় যে রাসায়নিক
          বিক্রিয়া ঘটে তা রাসায়নিক সমীকরণ দ্বারা উপস্থাপন করা যেতে পারে।
        </p>
      </div>
      {/* Content 5 */}
      <div className="mb-4">
        <p className="my-1">আণবিক সমীকরণ</p>
        <img src={Image03} alt="simulation-theory" className="py-2" />
        <div className="mt-1 flex flex-wrap">
          <p>সামগ্রিক প্রতিক্রিয়া : </p>
          <img src={Image04} alt="simulation-theory" className="ml-1" />
        </div>
      </div>
      {/* Content 6 */}
      <div className="mb-4">
        <p className="my-1">আয়নিক সমীকরণ</p>
        <img src={Image05} alt="simulation-theory" className="py-2" />
        <div className="mt-1 flex flex-wrap">
          <p>সামগ্রিক প্রতিক্রিয়া : </p>
          <img src={Image06} alt="simulation-theory" className="ml-1" />
        </div>
      </div>
      {/* Content 7 */}
      <div className="pb-5">
        <h2 className="font-semibold mb-1"> সুষম রাসায়নিক সমীকরণ </h2>
        <p>
          সুষম রাসায়নিক সমীকরণ থেকে, এটা স্পষ্ট যে KMnO₄ এর 2 টি মোল অক্সালিক
          অ্যাসিডের 5 মোলের সাথে বিক্রিয়া করে।
          <br />
          মোলারিটি সমীকরণ অনুসারে,
        </p>
        <img src={Image07} alt="simulation-theory" className="mt-2" />
        <div className="mt-4 flex flex-wrap">
          <p>অতএব, KMnO₄ এর মোলারিটি = </p>
          <img src={Image08} alt="simulation-theory" className="ml-1 -mt-4" />
        </div>
        <p>
          যদি অক্সালিক অ্যাসিড টাইট্রেট করতে হয়, তবে প্রয়োজনীয় পরিমাণে ডাইলুট
          সালফিউরিক অ্যাসিড যোগ করুন এবং ফ্লাস্কটিকে 60°-70°C তাপমাত্রায় গরম
          করুন। গরম করার উদ্দেশ্য হল প্রতিক্রিয়ার হার বাড়ানো, যা অন্যথায় ঘরের
          তাপমাত্রায় ধীর।
        </p>
      </div>

      {/* Content 9 */}
      <div className="pb-5">
        <h2 className="font-semibold mb-1"> শেখার ফলাফল: </h2>
        <ul className="list-inside leading-loose list-disc">
          <li>
            শিক্ষার্থীরা শর্তাবলী বুঝবে - ভলিউমেট্রিক বিশ্লেষণ, মোলারিটি,
            মোলালিটি স্বাভাবিকতা এবং রেডক্স টাইট্রেশন।
          </li>
          <li>
            শিক্ষার্থীরা মোলারিটি সমীকরণ ব্যবহার করে KMnO₄ এর শক্তি গণনা করার
            জন্য জ্ঞান অর্জন করবে
          </li>
          <li>
            শিক্ষার্থীরা ডাইলুট সালফিউরিক অ্যাসিড যোগ করার উদ্দেশ্য এবং
            টাইট্রেশনের আগে অক্সালিক অ্যাসিড গরম করার উদ্দেশ্য বুঝবে।
          </li>
          <li>
            শিক্ষার্থীরা অক্সালিক অ্যাসিড এবং মোহরের লবণের মানক সমাধান প্রস্তুত
            করার দক্ষতা অর্জন করবে{' '}
          </li>
          <li> শিক্ষার্থীরা টাইট্রেশনের জন্য ব্যবহৃত যন্ত্রপাতি বুঝবে।</li>
          <li>
            শিক্ষার্থীরা বিভিন্ন ধাপ বোঝার পর বাস্তব ল্যাবে রেডক্স-টাইট্রেশন
            করার দক্ষতা অর্জন করে।{' '}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CheTheoryTemplate;
